import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ConnectedServiceDeskAndCodeBench } from '../../apps/service-desk/service-desk-and-codebench.component';
import { CoderTopSection } from '../../components/coder-top-section/coder-top-section';
import './CoderViewContainer.scss';

const HEADER_SLOT_SELECTOR = '[data-coder-header-slot]';

// CDMX-15947 — worklist V2. Renders the existing (SDK) worklist full-bleed and
// portals the coder "My Work" top section into the worklist's header slot, so it
// sits in the content column above the tabs, to the right of the full-height nav.
// The SDK is a separate ReactDOM root, so a portal (not a child) keeps the top
// section in dashboard-ui's tree with Redux + Chakra context and live data.
export const CoderViewContainer: React.FC<any> = routeProps => {
  const [slotEl, setSlotEl] = useState<HTMLElement | null>(null);
  const isCaseOpen = routeProps.match?.params?.id !== undefined;

  useEffect(() => {
    const findSlot = () => {
      const el = document.querySelector(
        HEADER_SLOT_SELECTOR
      ) as HTMLElement | null;
      // Only update when the node identity actually changes (the SDK may
      // re-render and replace the placeholder).
      setSlotEl(prev => (prev === el ? prev : el));
    };

    findSlot();
    const observer = new MutationObserver(findSlot);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="cmx-coder-view" data-testid="coder-view">
      <div className="cmx-coder-view__worklist" data-testid="coder-view-worklist">
        <ConnectedServiceDeskAndCodeBench {...routeProps} coderViewV2 />
      </div>
      {slotEl && !isCaseOpen ? createPortal(<CoderTopSection />, slotEl) : null}
    </div>
  );
};

CoderViewContainer.displayName = 'CoderViewContainer';
export default CoderViewContainer;
